module.exports = __webpack_public_path__ + "static/media/logo-green@200x.e8951fa4.png";